import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../../UI/Typography'
import SplitSection from '../../UI/Slider/SplitSection'
import Button from '../../UI/Button'
import TabSlider from '../../UI/TabSlider'
import { device } from '../../../utils/helpers'
// import SabbiaLogo from '../../../assets/images/strutture/campi/beachvolley/sabbia-logo.png'

import Feature from '../../UI/Feature'
import { features } from './Contenimento'

import {
  beachSlides1,
  beachSlides2,
  beachSlides3
} from '../../Helpers/Slides'
import {
  Section,
  Title,
  BigTitle,
  FeatureWrapper,
  Features,
  Content
} from './Altre'

export const beach = {
  description: 'L’installazione temporanea di un campo da beach volley in un contesto diverso dalla spiaggia genera sempre un grande interesse. La nostra sabbia è certificata e viene utilizzata nelle competizioni ufficiali di questo bellissimo sport.',
  tabs: [
    {
      title: 'Rete',
      content: 'La rete da gioco è regolabile in altezza e comprende la coppia di antenne bianco-rosse in fibra di vetro per delimitare il campo di gioco.;È possibile inoltre personalizzare la rete da gioco sul perimetro in PVC della stessa.',
      goToSlideIndex: 2
    },
    {
      title: 'Pali',
      content: 'Impianto beach volley professionale con pali per sostegno rete: diametro 102 mm tropicalizzato, scorrevoli tropicalizzati, completo di tendirete, basamento in acciaio con travi di legno per aumentare la stabilità.',
      goToSlideIndex: 1
    },
    {
      title: 'Linee',
      content: 'Nastro segnacampo completo di ancoraggi e picchetti in acciaio.',
      goToSlideIndex: 0
    },
    {
      title: 'SEGGIOLONE ARBITRO',
      content: 'Seggiolone arbitro beach-volley chiudibile con struttura in acciaio, superfici di appoggio 120x60 cm e piano di calpestio in lamiera di alluminio zigrinata antiscivolo.',
      goToSlideIndex: 0
    }
  ]
}

export const sabbia = {
  description: 'Le sabbie naturali, fornite in collaborazione con Minerali Industriali Sport&Leisure, forniscono un’esperienza di gioco sensazionale. L’elevata qualità delle sabbie utilizzate è frutto della loro natura minerale e degli accurati controlli granulometrici e chimici a cui sono sottoposte. Tutto ciò riduce al minimo la polverosità e le rende facili da rimuovere dalla pelle e dagli indumenti, mantenendo nel tempo la sofficità e la leggerezza del campo da gioco.'
}

const SubSection = styled.div`

  @media ${device.laptopL} {
    display: flex;
    justify-content: space-between;
  }
`

const Image = styled.img`
  width: 100px;
  height: 100px;
`

class CampoBeach extends Component {
  render () {
    return (
      <div>
        <Helmet>
          <title>Campo beach volley</title>
          <meta name='Description' content='Noleggio campo beach volley: rete, sabbia, seggiolone arbitro, pali e linee segnacampo e tutti gli accessori per rendere perfetto il tuo evento!' />
          <meta name='Keywords' content='noleggio campo beach volley,campo beach volley,sabbia beach volley prezzo' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>CAMPO DA BEACH VOLLEY</Typography>
        </Title>
        <Content>
          {/* BEACH VOLLEY */}
          <SplitSection slides={beachSlides1} reverse reverseMobile>
            <Typography variant='h2' type='title'>BEACH VOLLEY</Typography>
            <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
              {beach.description}
            </Typography>
            <SubSection>
              <div>
                <Typography padding='1.2rem 0' variant='h5' type='title'>SPECIFICHE</Typography>
                <span style={{ color: '#999999' }}>16x8 m (ingombro 20x12 m)</span> <br />
                <span style={{ color: '#999999' }}>Protezione laterale con rete (altezza 3 m)</span> <br />
                <span style={{ color: '#999999' }}>Impianto di illuminazione</span> <br />
                <span style={{ color: '#999999' }}>Impianto audio e diffusione sonora</span> <br />
              </div>
              <div>
                <Typography padding='1.2rem 0' variant='h5' type='title'>NOLEGGIA UN CAMPO PER IL TUO EVENTO!</Typography>
                <Button size='small' primary to='/noleggia/beach-volley/1'>CREA PREVENTIVO</Button>
              </div>
            </SubSection>
          </SplitSection>
          <TabSlider
            slides={beachSlides2}
            tabs={beach.tabs}
            title='Dettagli Tecnici'
          />
          {/* LA SABBIA */}
          <SplitSection slides={beachSlides3} reverse>
            <Typography variant='h3' type='title'>LA SABBIA</Typography>
            <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
              {sabbia.description}
            </Typography>
            {/* <Image src={SabbiaLogo} alt='Sabbia' /> */}
          </SplitSection>
        </Content>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>
              4 BUONI MOTIVI PER SCEGLIERE LE NOSTRE STRUTTURE
            </Typography>
          </BigTitle>
          <Features>
            {features.map(feature => (
              <FeatureWrapper>
                <Feature
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              </FeatureWrapper>
            ))}
          </Features>
        </Section>
      </div>
    )
  }
}

export default CampoBeach



// WEBPACK FOOTER //
// ./src/components/Pages/Strutture/CampoBeach.js